import { Row } from "../models/shipeezi.table";
import { saveRowsSelectedFromTable } from "./selectRowsFromTable";

export const onSaveItemSelected = (
  rowsId: number[],
  rows: Row[],
  data: any,
  removeRows?: (rows: number[]) => number[]
) => {
  if (rowsId.length === 0) return [];

  let ids = rowsId;

  if (removeRows) ids = removeRows(rowsId);

  return saveRowsSelectedFromTable(ids, rows, data);
};
